import { S as Swiper } from './index-od979Ty0.js';
import './swiper-core-RAYWN467.js';
import './classes-to-selector-M_EnDm_N.js';

class Quicklinks extends HTMLElement {
  modules = [];

  connectedCallback() {
    this.initSwiper();
  }

  initSwiper() {
    this.swiper = Swiper(this, {
      modules: this.modules,
      slidesPerView: 'auto',
      spaceBetween: 12,
      breakpoints: {
        768: {
          spaceBetween: 12,
        },
        1440: {
          spaceBetween: 12,
        },
      },
    });
  }
}

customElements.define('quicklinks-swiper', Quicklinks);
